import { Component } from "@angular/core";
import { TransactionHistoryService } from "@app/services/transactionHistory/transactionHistory.service";
import { ValueType } from "@app/common/valuetype";
import { TransactionFilterModel } from "@app/models/customer-transaction-history/Transaction-Filter-model";
import { HelpDeskModel, TicketCountModel } from "@app/models/merchant-settlement-model/merchant-settlement-model";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
    selector: 'HelpDesk',
    templateUrl: './helpDesk.component.html',
})
export class HelpDeskComponent {
    EntityTypeId: string = "0";

    ngOnInit() {
        this.EntityTypeId = localStorage.getItem('EntityType');
        this.setDate();
        this.route.params.subscribe(params => {
            if (params['MerchantId']) {
                this.issuerFilter.MerchantCode = params['MerchantId'];
                //this.getIssuerDetails();
            }
            if (params['OutletId']) {
                this.issuerFilter.OutletId = params['OutletId'];
                //this.getIssuerDetails();
            }
            if (params['TerminalId']) {
                this.issuerFilter.TerminalId = params['TerminalId'];
                console.log(this.issuerFilter.TerminalId);
            }
        });
        this.getIssuerDetails();
        this.getIssuerType();
        this.getIssuerStatus();
        this.getTicketType();
        this.getTicketCount();
    }
    constructor(private transactionhistoryService: TransactionHistoryService, private router: Router,
        private route: ActivatedRoute) { }

    issuerType = new Array<ValueType>();
    issuerStatus = new Array<ValueType>();
    ticketType = new Array<ValueType>();
    issuerFilter = new HelpDeskModel();
    issuerDetails = new Array<HelpDeskModel>();
    ticketCount = new TicketCountModel();
    pageNumber: number = 0;
    itemPerPage: number = 10;
    tempCount: number;
    SkipCount: number;
    tempTicket: number;

    getIssuerType() {
        this.transactionhistoryService.getIssuerType().subscribe(data => {
            this.issuerType = JSON.parse(JSON.stringify(data));
        });
    }

    getIssuerStatus() {
        this.transactionhistoryService.getIssuerStatus().subscribe(data => {
            this.issuerStatus = JSON.parse(JSON.stringify(data));
        });
    }

    getTicketType() {
        this.transactionhistoryService.getTicketType().subscribe(data => {
            this.ticketType = JSON.parse(JSON.stringify(data));
        });
    }

    setDate() {
        var date = new Date();
        this.issuerFilter.FromDate = new Date(date.getFullYear(), date.getMonth(), 1);
        this.issuerFilter.ToDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    getIssuerDetails() {
        // debugger
        this.tempTicket = undefined;
        this.SkipCount = 0;
        this.issuerFilter.TerminalCode = this.issuerFilter.TerminalId;
        this.transactionhistoryService.getIssuerDetails(this.issuerFilter).subscribe(data => {
            this.issuerDetails = JSON.parse(JSON.stringify(data));
            this.tempCount = this.issuerDetails.length;
            for (var issuerdata of this.issuerDetails) {
                if (issuerdata.OutletId == this.issuerFilter.OutletId)
                    this.issuerFilter.OutletName = issuerdata.OutletName
            }
        });
    }

    pageControl(event: number, sortName: string) {
        this.pageNumber = event;
        this.bindPaginationDate(10 * (this.pageNumber - 1));
    }

    bindPaginationDate(offset: number) {
        // debugger
        this.SkipCount = offset;
        if (this.tempTicket == 1) {
            this.getOpenTicketDetails(this.tempTicket);
        }
        if (this.tempTicket == 2) {
            this.getCloseTicketDetails(this.tempTicket);
        }
        if (this.tempTicket == 3) {
            this.getInProgressTicketDetails(this.tempTicket);
        }
        if (this.tempTicket == undefined) {
            this.getIssuerDetails();
            //// SHOWING OPEN TICKETS BY DEFAULT
            //this.getIssuerDetails();
        }
    }

    getTicketCount() {
        this.transactionhistoryService.getTicketCount(this.issuerFilter).subscribe(data => {
            this.ticketCount = JSON.parse(JSON.stringify(data));
        });
    }

    getOpenTicketDetails(tempTicket) {
        // debugger
        this.SkipCount = 0;
        this.tempTicket = tempTicket;
        this.transactionhistoryService.getOpenTicketDetails(this.issuerFilter).subscribe(data => {
            this.issuerDetails = JSON.parse(JSON.stringify(data));
            this.tempCount = this.issuerDetails.length;
        });
    }

    getCloseTicketDetails(tempTicket) {
        this.SkipCount = 0;
        this.tempTicket = tempTicket;
        this.transactionhistoryService.getCloseTicketDetails(this.issuerFilter).subscribe(data => {
            this.issuerDetails = JSON.parse(JSON.stringify(data));
            this.tempCount = this.issuerDetails.length;
        });
    }

    getInProgressTicketDetails(tempTicket) {
        this.SkipCount = 0;
        this.tempTicket = tempTicket;
        this.transactionhistoryService.getInProgressTicketDetails(this.issuerFilter).subscribe(data => {
            this.issuerDetails = JSON.parse(JSON.stringify(data));
            this.tempCount = this.issuerDetails.length;
        });
    }

    showIssueDetails(TicketId, IssueType) {
        if(this.EntityTypeId=='115'){
            this.router.navigate(['/secure/admin/issueDetails/' + TicketId + '/' + IssueType]);
        }
        else{
            this.router.navigate(['/app/merchant/issueDetails/' + TicketId + '/' + IssueType]);
        }
    }

    keyPressNumberMerchantCode(event: any) {
        const pattern = /[0-9]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            // this.errorMessagePinCode = "Enter only numbers";
            event.preventDefault();
        }
        else {
            // this.errorMessagePinCode = "";
        }
    }

    keyPressNumber(event: any) {
        const pattern = /[0-9]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            // this.errorMessagePinCode = "Enter only numbers";
            event.preventDefault();
        }
        else {
            // this.errorMessagePinCode = "";
        }
    }
    extraCssAsPerSelection(status:string)
    {
        switch(status)
        {
            case 'open':
           {
            if(this.tempTicket ==1 || this.tempTicket == undefined)
                return "daily_btn_active";
            break;              

           }
           case 'closed':
           {
            if(this.tempTicket ==2)
             return "daily_btn_active";
            break;
           }
           case 'inprogress':
           {
            if(this.tempTicket ==3)
             return "daily_btn_active";
            break;
           }
        }
    }

    getTotalRecordForHelpDesk = () => {
        return this.transactionhistoryService.getIssuerDetails(this.issuerFilter)
            .map(a => JSON.parse(JSON.stringify(a)).map(b => {
                return {
                    'Ticket Id': JSON.parse(JSON.stringify(b)).TicketId,
                    'Outlet Name': JSON.parse(JSON.stringify(b)).OutletName,
                    'Issue Type': JSON.parse(JSON.stringify(b)).IssueTypeData,
                    'Raised On': JSON.parse(JSON.stringify(b)).RaisedOnDate,
                    'Raised By': JSON.parse(JSON.stringify(b)).RaisedBy,
                    'Status': JSON.parse(JSON.stringify(b)).StatusData
                };
            }));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/help-desk/helpDesk.component.ts